import React, { Component } from 'react';
import { Heading, RadioGroup, Call } from '../../../../../../UiKit';
import { getFormData } from '../../../../../commons/CommonMethods';

import './Stepper.scss';

export default class Stepper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.stepperData,
      selectedOptions: [],
    };
    this.bodyParams = {};
    this.timerId1 = null;
    this.timerId2 = null;
  }

  componentWillMount = () => {
    this.initializeStepper();
  };

  componentWillUnmount = () => {
    clearTimeout(this.timerId1);
    clearTimeout(this.timerId2);
  };

  initializeStepper = () => {
    const { stepperData } = this.props;
    stepperData[0]['is_active'] = true;
    stepperData[0]['is_done'] = true;
    stepperData[0]['is_reject'] = false;
    this.setState({
      data: stepperData,
    });
  };

  resetActiveFlag = () => {
    // set all to inactive
    const { data } = this.state;
    data &&
      data.map((item) => {
        item['is_active'] = false;
        return true;
      });
  };

  setFlags = (currentIndex, isActive, isDone, isReject = false) => {
    // mark active,done, reject according to arguments
    const { data } = this.state;
    const nextIndex = currentIndex + 1;
    this.resetActiveFlag();
    data[nextIndex]['is_active'] = isActive;
    data[nextIndex]['is_done'] = isDone;
    if (data[currentIndex]) data[currentIndex]['is_reject'] = isReject;
    this.setState({
      data: data,
    });
  };

  setAllRejectAfterCurrentIndex = (currentIndex) => {
    const { data } = this.state;
    data &&
      data.map((item, index) => {
        if (index >= currentIndex) {
          item['is_active'] = false;
          item['is_done'] = false;
          item['is_reject'] = true;
        }
        return true;
      });
    this.setState({
      data: data,
    });
  };

  selectRadioOption = (index, item, value, selectedRadioOption) => {
    const { selectedOptions } = this.state;
    let currentOption = [],
      radioData;
    if (selectedRadioOption?.status === 'failed') {
      item.is_reject = true;
    } else {
      delete item?.is_reject;
    }
    if (item.radio) {
      radioData = getFormData(item.radio, value);
    }

    currentOption.push(radioData);

    this.setState({
      selectedOptions: [...selectedOptions, radioData],
    });
  };

  getAllRadioOptions = () => {
    const { selectedOptions } = this.state;
    if (!selectedOptions?.length) return null;
    let finalObj = {};
    for (let i = 0; i < selectedOptions.length; i++) {
      finalObj = { ...finalObj, ...selectedOptions[i] };
    }
    return finalObj;
  };

  markAsDone = (currentIndex, item, status) => {
    const { data, selectedOptions } = this.state;
    const { handleStepperSubmission } = this.props;
    const button = data[currentIndex].submit_button;
    this.bodyParams[button.key] = button.value;

    if (item.radio && !selectedOptions[currentIndex]) return;

    if (currentIndex === data.length - 1) {
      let allSelectedRadioOptions = this.getAllRadioOptions();
      Object.assign(this.bodyParams, allSelectedRadioOptions);
      this.timerId1 = setTimeout(() => {
        this.resetActiveFlag();
        return handleStepperSubmission(true, button.url, this.bodyParams);
      }, 0);
      return;
    }
    this.setFlags(
      currentIndex,
      status.is_active,
      status.is_done,
      status.is_reject,
    );
  };

  markAsReject = (currentIndex) => {
    const { data } = this.state;
    const { handleStepperSubmission } = this.props;
    const button = data[currentIndex].reject_button;

    if (button.url) {
      const last = currentIndex === data.length - 1 ? true : false;
      this.setAllRejectAfterCurrentIndex(currentIndex);
      this.bodyParams[button.key] = button.value;
      this.timerId2 = setTimeout(() => {
        last && this.resetActiveFlag();
        return handleStepperSubmission(last, button.url, this.bodyParams);
      }, 0);
    } else {
      this.setFlags(currentIndex, true, true, true);
    }
  };

  render() {
    const { data, selectedOptions } = this.state;
    const { orderId, userId } = this.props;
    return (
      <div className='stepper'>
        <ul className='step_progress'>
          {data &&
            data.map((item, index) => {
              // is_done class for blue tik icon
              let isDone = item.is_done ? 'is_done' : '';
              // is_reject class for red cross icon
              let isReject = item.is_reject ? 'is_reject' : '';
              // show bottom options only for active item
              let display = item.is_active ? 'block' : 'none';

              let isDisabled =
                item.radio && !selectedOptions[index] ? true : false;
              let status = {
                is_active: item.is_active,
                is_done: item.is_done,
                is_reject: item.is_reject,
              };

              return (
                <React.Fragment key={index}>
                  <li
                    className={`step_progress_item ${isDone} ${isReject}`}
                    key={index}
                  >
                    <strong>
                      {item.title.text}
                      {item.is_active && (
                        <span className='iconMarginL pointer'>
                          <Call
                            phone_numbers={item?.phone_numbers}
                            orderId={orderId}
                            userId={userId}
                            calledTo={item?.called_to || ''}
                          />
                        </span>
                      )}
                    </strong>
                    <div className='step_content' style={{ display: display }}>
                      {item.subtitle.text}
                      {item.radio && item.radio.source.length && (
                        <div className='pt20 col'>
                          {item.radio.title && (
                            <Heading title={item.radio.title.text} />
                          )}
                          <RadioGroup
                            items={item.radio.source}
                            selectOption={this.selectRadioOption.bind(
                              this,
                              index,
                              item,
                            )}
                          />
                        </div>
                      )}
                      <div className='row btns'>
                        {item.submit_button && (
                          <div
                            className={`submit_btn btn ${
                              isDisabled ? 'disable' : ''
                            }`}
                            onClick={this.markAsDone.bind(
                              this,
                              index,
                              item,
                              status,
                            )}
                            data-dd-action-name='Stepper Done'
                          >
                            {item.submit_button.text}
                          </div>
                        )}
                        {item.reject_button && (
                          <div
                            className='reject_btn btn'
                            onClick={this.markAsReject.bind(this, index)}
                            data-dd-action-name='Stepper Reject'
                          >
                            {item.reject_button.text}
                          </div>
                        )}
                      </div>
                    </div>
                  </li>
                </React.Fragment>
              );
            })}
        </ul>
      </div>
    );
  }
}
